(function () {
  const SELECTOR = '[data-wine-shipping-progress]';

  function getBottleWord(count) {
    return count === 1 ? 'Flasche' : 'Flaschen';
  }

  function updateProgressBar(bar, cart) {
    const targetBottles = Number(bar.dataset.targetBottles || 24);
    const targetWeight = Number(bar.dataset.targetWeight || 24000);
    const gramsPerBottle = Number(bar.dataset.gramsPerBottle || 1000);

    const currentWeight = Number(cart.total_weight || 0);
    const currentBottles = Math.floor(currentWeight / gramsPerBottle);

    const missingBottles = Math.max(
      0,
      Math.ceil((targetWeight - currentWeight) / gramsPerBottle)
    );

    const progress = Math.min(
      100,
      Math.round((currentWeight / targetWeight) * 100)
    );

    const copy = bar.querySelector('.wine-shipping-progress__copy');
    const fill = bar.querySelector('.wine-shipping-progress__fill');
    const track = bar.querySelector('.wine-shipping-progress__track');

    if (!copy || !fill || !track) return;

    if (currentWeight >= targetWeight) {
      copy.innerHTML = `
        <p class="wine-shipping-progress__headline">
          Dein Versand ist kostenfrei
        </p>
        <p class="wine-shipping-progress__subline">
          ${targetBottles} Flaschen erreicht. Der Versand geht auf uns.
        </p>
      `;
    } else {
      copy.innerHTML = `
        <p class="wine-shipping-progress__headline">
          Nur noch ${missingBottles} ${getBottleWord(missingBottles)} bis zum kostenfreien Versand
        </p>
        <p class="wine-shipping-progress__subline">
          ${currentBottles} von ${targetBottles} Flaschen erreicht.
        </p>
      `;
    }

    fill.style.width = `${progress}%`;
    track.setAttribute('aria-valuenow', String(progress));
  }

  async function refreshWineShippingProgress() {
    const bars = document.querySelectorAll(SELECTOR);
    if (!bars.length) return;

    const root =
      window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root
        : '/';

    try {
      const response = await fetch(`${root}cart.js`, {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) return;

      const cart = await response.json();

      bars.forEach((bar) => updateProgressBar(bar, cart));
    } catch (error) {
      console.warn('Wine shipping progress could not be refreshed.', error);
    }
  }

  document.addEventListener('DOMContentLoaded', refreshWineShippingProgress);

  document.addEventListener('cart:updated', refreshWineShippingProgress);
  document.addEventListener('cart:change', refreshWineShippingProgress);
  document.addEventListener('ajaxCart:updated', refreshWineShippingProgress);
  document.addEventListener('ajaxProduct:added', refreshWineShippingProgress);
  document.addEventListener('drawerOpen.CartDrawer', refreshWineShippingProgress);

  document.addEventListener('click', function (event) {
    const target = event.target;

    if (
      target.closest('button[name="add"]') ||
      target.closest('button[name="plus"]') ||
      target.closest('button[name="minus"]') ||
      target.closest('[data-cart-remove]') ||
      target.closest('[data-add-to-cart]') ||
      target.closest('.js-qty__adjust') ||
      target.closest('.quantity__button') ||
      target.closest('.cart__remove') ||
      target.closest('cart-remove-button')
    ) {
      window.setTimeout(refreshWineShippingProgress, 500);
      window.setTimeout(refreshWineShippingProgress, 1000);
    }
  });

  document.addEventListener('change', function (event) {
    const target = event.target;

    if (
      target.matches('input[name="updates[]"]') ||
      target.matches('.quantity__input') ||
      target.matches('.js-qty__num')
    ) {
      window.setTimeout(refreshWineShippingProgress, 500);
      window.setTimeout(refreshWineShippingProgress, 1000);
    }
  });
})();